// extracted by mini-css-extract-plugin
var _1 = "YK0JX";
var _2 = "DNoA5";
export { _1 as "dragImage", _2 as "draggedItem" }
